module.exports = __webpack_public_path__ + "5c78585b80fbf4342d21674a04e89c8b.png";